const songRelationshipTitles = {
  samples: 'Samples',
  sampled_in: 'Sampled In',
  interpolates: 'Interpolates',
  interpolated_by: 'Interpolated By',
  cover_of: 'Cover Of',
  covered_by: 'Covered By',
  remix_of: 'Remix Of',
  remixed_by: 'Remixed By',
  live_version_of: 'Live Version Of',
  performed_live_as: 'Performed Live As'
};

export default songRelationshipTitles;
